export default "/fonts/vendor/element-plus/dist/element-icons.woff?dcdb1ef8559c7cb404ef680e05efcc64";